export default __webpack_public_path__ + "static/media/displayer_medmex.1785d2d0.png";